import { memo } from 'react';
import { useSelector } from 'react-redux';

import { ClipSearch } from '~/components/SearchCommand/SmartSearchImageSearchStatus/ClipSearch';
import { ImageUploadSearch } from '~/components/SearchCommand/SmartSearchImageSearchStatus/ImageUploadSearch';
import { useFilterParams } from '~/hooks/filters/useFilterParams';
import { similarToImageFilterSelector } from '~/store/filters/selectors';

export const SmartSearchImageSearchStatus = memo(() => {
  // Read from Redux for similarToImage (not in URL due to base64 size)
  const similarToImage = useSelector(similarToImageFilterSelector);

  // Read from URL for similarTo (URL is the source of truth)
  const { semanticClipSearchParam } = useFilterParams();
  const similarTo = semanticClipSearchParam?.is;

  if (similarToImage) {
    return <ImageUploadSearch similarToImage={similarToImage} />;
  }

  if (similarTo) {
    return <ClipSearch clipId={similarTo} />;
  }

  return null;
});

SmartSearchImageSearchStatus.displayName = 'SmartSearchImageSearchStatus';
